export { default as HeroBannerWithNewsTicker } from './HeroBannerWithNewsTicker';
